<template>
  <el-dialog class="dialog-create-plan" :title="pageType==='add' ?'添加线上课程': pageType==='edit' ? '修改线上课程' : '查看线上课程'"
    :visible.sync="dialogVisible" width="850px">
    <div class="wrap">
      <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">
        <el-form-item label="课程标题 :" prop="title">
          <el-input v-model="form.title" placeholder="请输入"
            :disabled="pageType==='detail' || pageType==='approval'"></el-input>
        </el-form-item>

        <el-form-item class="avatar-uploader-form" label="课程封面 :">
          <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="pageType == 'view'"
            accept="image/*" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="imgUrl" style="height:150px;width:100%;object-fit:contain;" :src="imgUrl" class="avatar">
            <div v-else>
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <div class="el-upload__text">上传课程封面</div>
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item class="avatar-uploader-form" label="课程视频 :">
          <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="pageType == 'view'"
            accept="video/*" :data="configData" :show-file-list="false" :on-progress="uploadVideoProcess"
            :on-success="handleVideoSuccess" :before-upload="beforeVideoUpload">
            <video v-if="videoUrl != '' && !videoFlag" v-bind:src="videoUrl" class="w-100 h-100" controls="controls">
              您的浏览器不支持视频播放
            </video>

            <div class="tip" v-else-if="videoUrl == '' && !videoFlag">
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <div class="el-upload__text">上传课程视频</div>
            </div>

            <el-progress v-if="videoFlag == true" type="circle" v-bind:percentage="videoUploadPercent"
              style="margin-top: 7px"></el-progress>
          </el-upload>
        </el-form-item>

      </el-form>
    </div>

    <div slot="footer" class="footer mt-30" v-if="pageType!=='detail'">
      <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">发布</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['imageTypes']),
  },
  data() {
    // let validateReceiptNumber = (rule, value, callback) => {
    //   if (!validate(value, 'numDecimal')) {
    //     return callback(new Error('最多支持两位小数'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      loadingSave: false,
      pageType: 'add', // 页面类型 add 新增  edit 编辑  detail 详情
      detailId: '', // 用户id
      form: {
      },
      configData: {
        tableName: 'collect'
      },
      videoFlag: false,
      videoUrl: "",
      videoUploadPercent: 0,
      imgUrl: "",
      typeList: [],
      dialogVisible: false,
      rules: {
        title: [{ required: true, message: '课程标题不能为空', trigger: 'blur' }],
      },
    }
  },
  methods: {
    init(type, id) {
      this.dialogVisible = true
      // 清空弹框数据
      this.pageType = type // 页面类型
      this.detailId = id || '' // 详情id
      // 新增或编辑
      if (this.detailId) {
        this.getDetailData()
      }
    },

    // 获取详情
    getDetailData() {
      this.$http
        .get('/bsCourseWeb/find', {
          informationId: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.form = res.result
            if (res.result.imgUrl) {
              this.imgUrl = res.result.imgUrl
            }

            if (res.result.fileIds) {
              this.videoUrl = res.result.fileList[0].attPath
            }

          } else {
            this.$message.error(res.message)
          }
        })
    },

    //进度条
    uploadVideoProcess(file, fileList) {    //注意在data中添加对应的变量名
      this.videoFlag = true // 显示进度条
      this.videoUploadPercent = parseInt(file.percent)
    },
    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      // if (!isLt2M) {
      //   this.$message({
      //     message: '上传文件大小不能超过 2MB!',
      //     type: 'warning'
      //   })
      //   return
      // }

      if (this.imageTypes.includes(fileType)) {
        return true

      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        this.form.img = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },
    beforeVideoUpload(file) {
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
          "video/mov",
        ].indexOf(file.type) == -1     //控制格式
      ) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
    },


    handleVideoSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.videoFlag = false;
        this.videoUploadPercent = 0;
        this.videoUrl = res.result.attPath
        this.form.fileIds = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },


    // 保存
    fromSubmit(form) {
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true
          this.$http
            .post('/bsCourseWeb/save', {
              ...this.form
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                if (this.pageType === 'edit') {
                  this.$message.success('线上课程编辑成功')
                } else if (this.pageType === 'add') {
                  this.$message.success('线上课程创建成功')
                }
                this.cancel()
                this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },

    // 取消
    cancel() {
      this.imgUrl = ""
      this.videoUrl = ""
      this.videoFlag = false
      this.$refs["form"].clearValidate()
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    },

  }
}
</script>

<style lang="scss" scoped>
.dialog-create-plan {
  /deep/ .el-form-item {
    &.avatar-uploader-form {
      display: flex;
      flex-direction: row;
      .el-form-item__content {
        margin-left: 0 !important;
        display: flex;
        flex: 1;
        .avatar-uploader {
          width: 50%;
          border: 1px dashed #8c939d;
          height: 150px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .el-upload {
            width: 100%;
            height: 150px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
          .el-icon-plus {
            font-size: 20px;
          }

          .el-upload__text {
            line-height: 1;
          }
        }
      }
    }
  }
}
</style>
